<template>
	<div
		class="inline-flex items-center justify-center rounded-full font-medium whitespace-nowrap"
		:class="[
			...classes,
			{
				'h-4 min-w-4 text-xs': size === 'sm',
				'h-7 min-w-5 px-1 text-xs leading-loose': size === 'base',
				'leading-2.7 h-6 min-w-6 px-1 text-xs': size === 'lg',
			},
		]"
	>
		<span
			:class="{
				'p-4': padding === 'base',
				'p-2': padding === 'sm',
			}"
		>
			<slot></slot>
		</span>
	</div>
</template>

<script setup lang="ts">
const properties = withDefaults(
	defineProps<{
		theme: keyof typeof themes;
		size?: "base" | "lg" | "sm";
		padding?: "base" | "sm";
	}>(),
	{
		size: "base",
		padding: "base",
	},
);

const themes: Record<string, string[]> = {
	white: ["text-gray-500", "bg-white"],
	primary: ["text-white", "bg-blue-500"],
	light: ["text-gray-500", "bg-gray-50"],
	secondary: ["text-gray-700", "bg-gray-200"],
	success: ["text-white", "bg-green-500"],
	info: ["text-white", "bg-purple-500"],
	warning: ["text-white", "bg-yellow-500"],
	danger: ["text-white", "bg-red-500"],
	dark: ["text-white", "bg-gray-700"],
	red: ["text-white", "bg-red-500"],

	"red-alt": ["text-red-500", "border", "border-red-500", "bg-transparent"],

	"light-primary": ["text-blue-500", "bg-blue-100"],

	"light-success": ["text-green-500", "bg-green-100"],

	"light-info": ["text-purple-500", "bg-purple-100"],

	"light-warning": ["text-yellow-500", "bg-yellow-100"],

	"light-danger": ["text-red-500", "bg-red-100"],

	"light-dark": ["text-gray-700", "bg-gray-100"],
};

const classes = computed(() => themes[properties.theme] ?? []);
</script>
